import { useIsSmallDevice } from '../useIsSmallDevice';

export const useValuesByScreenSize = <TValues,>(defaultValues: TValues, smallDeviceValues: TValues): TValues => {
	const isSmallDevice = useIsSmallDevice();

	return isSmallDevice ? smallDeviceValues : defaultValues;
};
